import React from "react";

import { EditPenIcon } from "@/assets/icons";
import { cn } from "@/lib/cn";

import { ActionButton } from "./ActionButton";

interface EditActionProps {
  disabled?: boolean;
  label?: string;
  /** The panel is being edited: the button stays pressed, in the accent, as an active tab does */
  active?: boolean;
  onEnableEdit: () => void;
}
export const EditAction = (props: EditActionProps) => {
  return (
    <ActionButton
      aria-label={props.label || "Edit"}
      aria-pressed={props.active === undefined ? undefined : props.active}
      title={props.active ? "Editing" : props.label || "Edit"}
      onClick={props.onEnableEdit}
      disabled={props.disabled}
      className={cn(props.active && "bg-accent text-primary-fg")}
    >
      <EditPenIcon />
    </ActionButton>
  );
};
